import templateUrl from './employment-timeline-report-download-modal.html'

export const EmploymentTimelineReportDownloadModalComponent = {
    bindings: {
        close: "<"
    },
    controller: class EmploymentTimelineDownloadModal {
        constructor(apexApiUrl, divisionService, utilityService) {
            'ngInject'
            this.apexApiUrl = apexApiUrl
            this.divisionService = divisionService
            this.utilityService = utilityService
        }

        $onInit() {
            this.divisionService.retrieveDivisions()
                .then(divisions => {
                    this.divisions = divisions;
                });
        }

        downloadReport() {
            if (!this.start || !this.end) {
                return;
            }

            const params = {
                start: this.start.toISOString(),
                end: this.end.toISOString(),
                divisionID: this.division ? this.division.Id : null
            }
            const queryString = this.utilityService.queryStringify(params);

            window.location.href = `${this.apexApiUrl}reports/employment-timeline.xlsx${queryString}`;
        }
    },
    templateUrl
}
